import facebookAnalytics from './facebookAnalytics';
import googleAnalytics from './googleAnalytics';
import { TrackEventProps } from '../types';

class Analytics {
  constructor() {
    this.trackScreenView = this.trackScreenView.bind(this);
    // this.addHistoryListener();
  }

  trackEvent({ eventName, category, label, customData: data }: TrackEventProps) {
    const customData = {
      ...data
    };
    facebookAnalytics.trackEvent({ eventName, category, label, customData });
    googleAnalytics.trackEvent({ eventName, category, label, customData });
  }

  // addHistoryListener() {
  //   history.listen(this.trackScreenView);
  // }

  trackScreenView(location) {
    this.trackEvent({ eventName: 'screen.view', customData: { screen: location.pathname } });
  }

  reportConversion(conversionId, callback) {
    googleAnalytics.reportConversion(conversionId, callback);
  }
}

const analytics = new Analytics();

analytics.trackScreenView(window.location);

export default analytics;
